import { useEffect } from "react";

const getModalSize = (size = "md") => {
  const sizes = {
    sm: "tw-max-w-[400px]",
    md: "tw-max-w-[600px]",
    lg: "tw-max-w-[800px]",
    xl: "tw-max-w-[1000px]",
    full: "tw-max-w-[90vw] tw-h-[90vh]",
  };
  return sizes[size];
};

const Modal = ({ isOpen, onClose, children, customHeight, backdrop = "", closeButton = false, size = "md" }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = () => {
    if (backdrop !== "static") {
      onClose();
    }
  };

  return (
    <div className={`tw-fixed tw-inset-0 tw-flex tw-justify-center tw-items-center tw-z-[9999] tw-bg-gray-900 tw-bg-opacity-50`} onClick={handleBackdropClick}>
      <div className={`tw-bg-white tw-rounded-lg tw-shadow-xl tw-w-full ${getModalSize(size)} ${customHeight ? customHeight : size === "full" ? "tw-h-[90vh]" : "tw-max-h-[90vh]"} tw-flex tw-flex-col`} onClick={(e) => e.stopPropagation()}>
        {closeButton && (
          <button onClick={onClose} className="tw-absolute tw-right-3 tw-top-2 tw-p-1 tw-rounded-full tw-hover:bg-gray-100 tw-transition-colors" aria-label="Close modal">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#101828">
              <path d="M256-213.85 213.85-256l224-224-224-224L256-746.15l224 224 224-224L746.15-704l-224 224 224 224L704-213.85l-224-224-224 224Z" />
            </svg>
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

Modal.displayName = "Modal";

const Header = ({ children }) => (
  <div className="tw-p-3 tw-border-b tw-border-gray-200 tw-flex-shrink-0">
    <div>{children}</div>
  </div>
);
Header.displayName = "Modal.Header";

const Body = ({ children }) => <div className="tw-p-3 tw-pt-0 tw-overflow-y-auto tw-flex-grow">{children}</div>;
Body.displayName = "Modal.Body";

const Footer = ({ children }) => <div className="tw-p-3 tw-border-t tw-border-gray-200 tw-flex tw-justify-end tw-gap-2 tw-flex-shrink-0">{children}</div>;
Footer.displayName = "Modal.Footer";

Modal.Header = Header;
Modal.Body = Body;
Modal.Footer = Footer;

export default Modal;
